module.exports = __webpack_public_path__ + "img/Presets_Icon_Up.68936bfe.svg";